<template>
  <div>
    <main>
      <div id="HomeContainer" style="background-color:#000; background-image:url(static/images/about-bg.jpg); background-size:100%;">
          <div class="ContentAligher relative" style="z-index:1;">

            <div class="row">
              <div class="col-md-5 col-md-offset-7">
                  <div id="HeroTitle">
                    <h1 class="bold"><span class="small">Elevating Principles</span>
                    <span class="mid"> With Elevated</span>
                    <span>Perspectives</span></h1>

                    <p>Experience, know-how and passion create an offering that is solution-oriented, for every requirement, be it functionally or aesthetically.</p>

                    <a v-on:click="scrollMeTo('ReadMore');">Read More</a>
                  </div>


              </div>
            </div>
            
          </div>


          <div  ref="ReadMore"></div>
          <div id="ServicesWrap">
            <div class="ContentAligher">
              
              <div id="Engneering-" class="sec">
                  <div class="row">
                    <div class="col-md-6 v_middle">
                      <img :src="require('./../../static/images/services/engineering.jpg')" class="responsive" />
                    </div><!--
                    --><div class="col-md-6 v_middle">
                          <p class="white">The owners of USC Elevator Interiors have been in the elevator business over 20 years and over the course of time have built long lasting partnerships with companies such as Otis Elevator, Related Management and Precision Elevator. We have completed new and remodeled elevators for the MTA, hotels, residential buildings, historical landmarks, and many more.</p><br/>

                          <p class="white">Take a look at our Our Client page to see the other companies we have worked with. When it comes to elevator interior we are prepared to take on challenging projects and put forth our 110% effort to satisfy our client’s styles and requests. Our services listed but not limited to installing new elevators, hoistway cladding, elevator flooring, architectural metals, lobby renovations, new cabs doors, leather installations and refurbishing elevators. USC Elevator Interiors has served the outer and surrounding Tri-State area.</p>

                      </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12"><br/><br/><br/></div>
                  </div>

                  <div data-speed="20" data-margin="200" data-rotate="0" data-rotatestatus="false" class="BGArrowLeft parallax"></div>

                  <div class="BGArrowRight parallax"  data-speed="-10" data-margin="-500" data-rotate="0" data-rotatestatus="false" ></div>
              </div>

            </div>




          </div>

      </div>
    </main>
   <!-- <rwv-our-clients></rwv-our-clients>-->
   <section id="OurClientsWrap">
    <div class="bg_yellow">
        <div class="ContentAligher SectionTopSpacing SectionBottomSpacing">
            <div class="row">
              <div class="col-xs-10 col-xs-offset-1 ">
                  <div class="row">
                    <div class="col-md-6 pull-right-md">
                        <h1 class="white bold">{{ title }}</h1>
                        <p>{{ description }}</p><br/>
                    </div>
                    <div class="col-md-6">
                      <div id="testimonialsWrap">
                        <img :src="require('@/assets/images/open-q.png')" id="quoteIcon">
                          <div class="row ">
                            <div class="col-md-11 innerBg">
                                <ul id="testimonialsSlider">
                                 <li v-for="testi in testimonials" @load="loaded"><p>{{ testi.testimonial }}</p><span>{{ testi.name }}</span><span>{{ testi.position_title }}</span></li>
                                </ul>
                              </div>
                            </div>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
        </div>
    </div>
  </section>
  </div>
</template>
<script>

//import RwvSubscribe from '@/components/Subscribe'
import * as $ from 'jquery'
import Vue from 'vue';
import VeeValidate from 'vee-validate';

import axios from 'axios'
import { API_BASE_URL } from '../config'
import { BASE_URL } from '../config'

Vue.use(VeeValidate);


import '@/assets/js/lightslider'

import RwvGeneralForm from '@/components/GeneralForm';
import RwvOurClients from '@/components/OurClients';

export default{
  name: 'About',
  components: {
    RwvGeneralForm, 
    RwvOurClients
  },
  data: function() {
    return {
     base_path: BASE_URL,
     title: 'Our Clients',
      description:'At USC Elevator Interiors we strive to ensure customer satisfaction and that starts by building relationships with some of the best elevator companies in the business. Our clients know that if they want precision, professionalism, and work that surpasses expectations, we are the ones for the job! ',
      testimonials:[],
    }
  },
  mounted() {

    axios.get(API_BASE_URL + 'testimonials/list/')
    .then(response => {this.testimonials = response.data}).finally(function(){
         $('#testimonialsSlider').lightSlider({
            item:1,
            slideMove:1,
            enableTouch:true,
            enableDrag:false,
            loop:false,
            slideMargin:0
          }); 

      });



  },
  updated(){
    
     $(".parallax").inertiaScroll({  parent: $("#SiteWrapper")  });
     setTimeout(function() {
          $(this).trigger('resize');
      }, 100);
  },
  methods: {
    loaded:function (e) {
        $(this).trigger('resize');
    },
    scrollMeTo(refName) {
        var element = this.$refs[refName];
        var top = element.offsetTop;
        window.scrollTo(0, top);
    },
  }
}

</script>
<style>
@import './../assets/css/lightslider.css';
</style>


// WEBPACK FOOTER //
// src/views/About.vue